import { Bar, mixins } from "vue-chartjs"
// KEEP ChartAnnotation import otherwise plugin not auto-loaded
// eslint-disable-next-line
import * as ChartAnnotation from "chartjs-plugin-annotation"
import uses_color_palette from "../../../mixins/UsesColorPalette"
import numeral from "numeral"

export default Bar.extend({
    mixins: [mixins.reactiveProp, uses_color_palette],
    mounted () {
        this.renderChart(this.chartData, this.options)
    },
    watch: {
        average: "reset"
    },
    methods: {
        reset () {
            if(this._chart) this._chart.destroy()
            this.renderChart(this.chartData, this.options)
        }
    },
    computed: {
        options () {
            return {
                tooltips: {
                    mode: "index",
                    callbacks: {
                        title: (tooltipItems, data) => {
                            let total = 0
                            data.datasets.forEach((dataset) => {
                                total += dataset.data[tooltipItems[0].index]
                            })
                            return `${tooltipItems[0].xLabel}: $ ${numeral(total).format("0,0")}`
                        },
                        label: function (tooltipItem, data) {
                            return `${data.datasets[tooltipItem.datasetIndex].label}: $ ${numeral(tooltipItem.value).format("0,0")}`
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        stack: "main",
                        ticks: {
                            beginAtZero: true,
                            // suggestedMax: this.yMax,
                            fontColor: "#00274F",
                            callback: function (value, index, values) {
                                const value_numeral = numeral(value)
                                values = value_numeral.value()
                                if(value >= 100000) return `$ ${numeral(value / 1000000).format("0,0.0")}M`
                                if(value >= 1000) return `$ ${numeral(value / 1000).format("0,0.0")}K`
                                return `$ ${value_numeral.format("0,0")}`
                            }
                        },
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        stack: "main",
                        scaleLabel: {
                            display: true,
                            labelString: "Date when project record was created",
                            fontSize: 10
                        },
                        ticks: {
                            fontSize: 10,
                            fontColor: "#00274F"
                        },
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: true,
                    reverse: true,
                    position: "bottom",
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                annotation: {
                    drawTime: "afterDatasetsDraw",
                    annotations: this.average ? [
                        {
                            type: "line",
                            mode: "horizontal",
                            scaleID: "y-axis-0",
                            value: this.average,
                            borderColor: this.color_on_hold.border,
                            borderWidth: 1,
                            label: {
                                backgroundColor: "transparent",
                                fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                                fontSize: 10,
                                fontStyle: "bold",
                                fontColor: this.color_on_hold.border,
                                position: "left",
                                xPadding: 3,
                                yPadding: 3,
                                xAdjust: 0,
                                yAdjust: 8,
                                cornerRadius: 0,
                                enabled: true,
                                content: `AVG $ ${numeral(this.average).format("0,0")}`
                            }
                        }
                    ] : []
                }
            }
        }
    },
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        average: {
            type: Number,
            default: 0
        }
    }
})
